<template>
  <div
    :class="{
      [$style.container]: true,
      [$style.active]: active,
    }"
    @click="$emit('click')"
  >
    <div :class="$style.content">
      <div
        v-if="$slots.hasOwnProperty('icon')"
        :class="$style.icon"
      >
        <slot name="icon"></slot>
      </div>

      <div :class="$style.info">
        <div
          v-if="$slots.hasOwnProperty('title')"
          :class="$style.title"
        >
          <slot name="title"></slot>
        </div>

        <div
          v-if="$slots.hasOwnProperty('description')"
          :class="$style.description"
        >
          <slot name="description"></slot>
        </div>
      </div>

      <responsive-controller v-if="$slots.hasOwnProperty('action')">
        <template #mobile>
          <div></div>
        </template>
        <template #default>
          <div :class="$style.action">
            <slot name="action"></slot>
          </div>
        </template>
      </responsive-controller>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionPanel',
  props: {
    active: Boolean,
  },
};
</script>

<style lang="sass" module>
  .container
    background-color: rgba(39, 40, 60, 0.5)
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)
    border-radius: 5px

    &:hover
      background-color: #2F3049
      cursor: pointer

    &.active
      background-color: #2F3049
      cursor: default

  .content
    display: flex
    align-items: center
    padding: 20px

  .icon
    margin-right: 20px

  .info
    overflow: hidden

  .title
    +text-ellipsis
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: rgba(255, 255, 255, 1)

    span
      white-space: nowrap

  .description
    +text-ellipsis
    font-weight: 500
    font-size: 12px
    line-height: 20px
    color: rgba(255, 255, 255, .5)

    span
      white-space: nowrap

  .action
    margin-left: auto
</style>
